import { render, staticRenderFns } from "./RankingHeader.vue?vue&type=template&id=ecf22364"
import script from "./RankingHeader.vue?vue&type=script&lang=js"
export * from "./RankingHeader.vue?vue&type=script&lang=js"
import style0 from "./RankingHeader.vue?vue&type=style&index=0&id=ecf22364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports